export const categories = [
  { slug: "all", name: "全部" },
  { slug: "action", name: "动作片", icon: "ri-sword-line" },
  { slug: "comedy", name: "喜剧片", icon: "ri-emotion-laugh-line" },
  { slug: "romance", name: "爱情片", icon: "ri-heart-line" },
  { slug: "scifi", name: "科幻片", icon: "ri-rocket-line" },
  { slug: "horror", name: "恐怖片", icon: "ri-ghost-line" },
  { slug: "anime", name: "动画片", icon: "ri-movie-line" },
  { slug: "drama", name: "剧情片", icon: "ri-film-line" },
  { slug: "tvseries", name: "电视剧", icon: "ri-tv-line" },
  { slug: "variety", name: "综艺", icon: "ri-mic-line" },
];

export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    slug: "wandering-earth-3",
    category: "scifi",
    year: 2026,
    rating: 8.8,
    duration: "148分钟",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健"],
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代勇敢地站出来，为人类的未来而战。这部震撼人心的科幻巨制延续了系列的高水准制作，视觉效果更加惊艳。",
    descriptionHtml: "<p>太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代勇敢地站出来，为人类的未来而战。</p><p>这部震撼人心的科幻巨制延续了系列的高水准制作，视觉效果更加惊艳。</p>",
    poster: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20Earth%20engines%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20glowing%20blue%20accents%2C%20epic%20scale%2C%20clean%20poster%20design%20with%20strong%20contrast&width=600&height=900&seq=movie-1&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20banner%20with%20massive%20Earth%20engines%20in%20deep%20space%2C%20dramatic%20atmospheric%20lighting%2C%20cinematic%20composition%2C%20dark%20cosmic%20background%2C%20film%20banner%20style&width=1400&height=600&seq=movie-1-banner&orientation=landscape",
    featured: true,
    tags: ["科幻巨制", "吴京", "视觉盛宴"],
    updateDate: "2026-07-28",
  },
  {
    id: 2,
    title: "长津湖之水门桥",
    slug: "water-gate-bridge",
    category: "action",
    year: 2025,
    rating: 9.1,
    duration: "149分钟",
    director: "徐克",
    cast: ["吴京", "易烊千玺", "段奕宏"],
    description: "电影以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了在结束了新兴里和下碣隅里的战斗之后，七连战士们又接到了更艰巨的任务——炸毁水门桥，阻断美军撤退路线。",
    descriptionHtml: "<p>电影以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了七连战士们接到了更艰巨的任务——炸毁水门桥。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20war%20film%20movie%20poster%20with%20soldiers%20in%20snowy%20battlefield%2C%20dramatic%20winter%20atmosphere%2C%20cold%20blue%20tones%2C%20cinematic%20lighting%2C%20epic%20war%20scene%2C%20clean%20poster%20design&width=600&height=900&seq=movie-2&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20winter%20war%20battlefield%20cinematic%20banner%20with%20soldiers%20in%20snow%2C%20dramatic%20cold%20atmosphere%2C%20cinematic%20composition%2C%20historical%20war%20film%20style&width=1400&height=600&seq=movie-2-banner&orientation=landscape",
    featured: true,
    tags: ["战争史诗", "历史巨制", "口碑佳作"],
    updateDate: "2026-07-25",
  },
  {
    id: 3,
    title: "热辣滚烫",
    slug: "hot-and-spicy",
    category: "comedy",
    year: 2025,
    rating: 8.2,
    duration: "129分钟",
    director: "贾玲",
    cast: ["贾玲", "雷佳音", "张小斐"],
    description: "善良的乐莹在经历了生活的重重打击后，选择勇敢地改变自己。她通过拳击找到了人生的方向和勇气，完成了一次华丽的蜕变。一部温暖治愈的喜剧电影。",
    descriptionHtml: "<p>善良的乐莹在经历了生活的重重打击后，选择勇敢地改变自己。她通过拳击找到了人生的方向和勇气，完成了一次华丽的蜕变。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20a%20woman%20boxing%20gloves%2C%20warm%20lighting%2C%20inspirational%20theme%2C%20cinematic%20portrait%20style%2C%20warm%20golden%20tones%2C%20clean%20poster&width=600&height=900&seq=movie-3&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Warm%20inspirational%20cinematic%20banner%20with%20boxing%20gym%20atmosphere%2C%20golden%20lighting%2C%20motivational%20theme%2C%20Chinese%20film%20style%2C%20soft%20dramatic%20composition&width=1400&height=600&seq=movie-3-banner&orientation=landscape",
    featured: true,
    tags: ["励志喜剧", "贾玲导演", "温暖治愈"],
    updateDate: "2026-07-20",
  },
  {
    id: 4,
    title: "封神第二部",
    slug: "creation-of-the-gods-2",
    category: "action",
    year: 2026,
    rating: 8.9,
    duration: "152分钟",
    director: "乌尔善",
    cast: ["费翔", "李雪健", "黄渤"],
    description: "殷商末年，纣王暴虐无道，天下大乱。姜子牙携封神榜下山，辅佐西岐武王伐纣。一场神魔大战即将展开，三界命运悬于一线。",
    descriptionHtml: "<p>殷商末年，纣王暴虐无道，天下大乱。姜子牙携封神榜下山，辅佐西岐武王伐纣。一场神魔大战即将展开。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20creatures%2C%20dramatic%20golden%20and%20red%20tones%2C%20epic%20scale%2C%20cinematic%20portrait%20style&width=600&height=900&seq=movie-4&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20cinematic%20banner%20with%20ancient%20battle%20scenes%2C%20golden%20dragons%20and%20warriors%2C%20dramatic%20skies%2C%20cinematic%20composition&width=1400&height=600&seq=movie-4-banner&orientation=landscape",
    featured: true,
    tags: ["神话史诗", "视觉奇观", "年度期待"],
    updateDate: "2026-07-30",
  },
  {
    id: 5,
    title: "你的婚礼",
    slug: "your-wedding",
    category: "romance",
    year: 2025,
    rating: 7.8,
    duration: "115分钟",
    director: "韩天",
    cast: ["许光汉", "章若楠"],
    description: "游泳特长生周潇齐与转校生尤咏慈长达十五年的爱情故事。从高中到大学，再到步入社会，他们在彼此的生命中留下了最深刻的印记。",
    descriptionHtml: "<p>游泳特长生周潇齐与转校生尤咏慈长达十五年的爱情故事。从高中到大学，再到步入社会，他们在彼此的生命中留下了最深刻的印记。</p>",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20youth%20movie%20poster%20with%20a%20couple%20on%20a%20beach%2C%20soft%20warm%20sunset%20lighting%2C%20nostalgic%20atmosphere%2C%20cinematic%20portrait%20style%2C%20clean%20poster&width=600&height=900&seq=movie-5&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Romantic%20cinematic%20banner%20with%20couple%20walking%20on%20sunset%20beach%2C%20warm%20golden%20lighting%2C%20nostalgic%20youth%20romance%20atmosphere%2C%20soft%20dreamy%20composition&width=1400&height=600&seq=movie-5-banner&orientation=landscape",
    featured: false,
    tags: ["青春爱情", "催泪", "许光汉"],
    updateDate: "2026-07-15",
  },
  {
    id: 6,
    title: "咒怨：起源",
    slug: "ju-on-origin",
    category: "horror",
    year: 2026,
    rating: 7.5,
    duration: "108分钟",
    director: "清水崇",
    cast: ["山崎贤人", "松冈茉优"],
    description: "一栋充满怨念的老宅，凡是踏入其中的人都将遭遇不可名状的恐怖。当一群年轻人为了探险进入这座宅邸，他们发现自己陷入了一个无法逃脱的诅咒循环。",
    descriptionHtml: "<p>一栋充满怨念的老宅，凡是踏入其中的人都将遭遇不可名状的恐怖。当一群年轻人进入这座宅邸，他们发现自己陷入了一个无法逃脱的诅咒循环。</p>",
    poster: "https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20a%20dark%20haunted%20house%2C%20eerie%20atmosphere%2C%20shadowy%20figure%2C%20cold%20blue%20and%20dark%20tones%2C%20cinematic%20horror%20style%2C%20clean%20poster&width=600&height=900&seq=movie-6&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Eerie%20horror%20cinematic%20banner%20with%20dark%20abandoned%20Japanese%20house%2C%20foggy%20atmosphere%2C%20cold%20blue%20tones%2C%20haunting%20cinematic%20composition&width=1400&height=600&seq=movie-6-banner&orientation=landscape",
    featured: false,
    tags: ["日式恐怖", "经典重启", "惊悚"],
    updateDate: "2026-07-18",
  },
  {
    id: 7,
    title: "深海2",
    slug: "deep-sea-2",
    category: "anime",
    year: 2026,
    rating: 8.5,
    duration: "135分钟",
    director: "田晓鹏",
    cast: ["杨凝", "山新"],
    description: "继前作之后，小女孩参宿再次进入神秘的海底世界。这次她将探索更深处的海洋秘境，遇见更多奇妙的生物，揭开深海隐藏的秘密。",
    descriptionHtml: "<p>继前作之后，小女孩参宿再次进入神秘的海底世界。这次她将探索更深处的海洋秘境，揭开深海隐藏的秘密。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20a%20girl%20in%20deep%20ocean%2C%20colorful%20marine%20life%2C%20magical%20underwater%20world%2C%20vibrant%20colors%2C%20dreamlike%20atmosphere%2C%20clean%20poster&width=600&height=900&seq=movie-7&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Magical%20underwater%20cinematic%20banner%20with%20colorful%20coral%20reefs%20and%20marine%20creatures%2C%20dreamlike%20ocean%20depths%2C%20vibrant%20blue%20and%20pink%20tones%2C%20animated%20film%20style&width=1400&height=600&seq=movie-7-banner&orientation=landscape",
    featured: false,
    tags: ["国漫之光", "视觉盛宴", "深海"],
    updateDate: "2026-07-22",
  },
  {
    id: 8,
    title: "坚如磐石",
    slug: "solid-as-rock",
    category: "drama",
    year: 2025,
    rating: 8.0,
    duration: "128分钟",
    director: "张艺谋",
    cast: ["雷佳音", "张国立", "于和伟"],
    description: "一名普通警察在一起案件中意外发现了一个惊天秘密，他不得不在正义与亲情之间做出艰难的选择。一场关于权力、金钱与人性的较量就此展开。",
    descriptionHtml: "<p>一名普通警察在一起案件中意外发现了一个惊天秘密，他不得不在正义与亲情之间做出艰难的选择。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20police%20officer%20in%20dark%20city%2C%20noir%20lighting%2C%20tense%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20style%2C%20clean%20poster&width=600&height=900&seq=movie-8&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Noir%20crime%20thriller%20cinematic%20banner%20with%20dark%20city%20streets%20at%20night%2C%20dramatic%20neon%20lighting%2C%20tense%20atmosphere%2C%20Chinese%20urban%20setting%2C%20cinematic%20composition&width=1400&height=600&seq=movie-8-banner&orientation=landscape",
    featured: false,
    tags: ["张艺谋", "犯罪悬疑", "实力派"],
    updateDate: "2026-07-10",
  },
  {
    id: 9,
    title: "长安三万里2",
    slug: "chang-an-2",
    category: "anime",
    year: 2026,
    rating: 8.7,
    duration: "168分钟",
    director: "谢君伟",
    cast: ["杨天翔", "凌振赫"],
    description: "延续前作的史诗叙事，影片继续讲述大唐诗人们的传奇故事。从安史之乱到盛世余晖，一个时代的辉煌与悲壮在银幕上徐徐展开。",
    descriptionHtml: "<p>延续前作的史诗叙事，影片继续讲述大唐诗人们的传奇故事。从安史之乱到盛世余晖，一个时代的辉煌与悲壮在银幕上徐徐展开。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20with%20Tang%20dynasty%20poets%2C%20ancient%20Chinese%20architecture%2C%20golden%20warm%20tones%2C%20classical%20painting%20style%2C%20elegant%20composition&width=600&height=900&seq=movie-9&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cinematic%20banner%20with%20traditional%20architecture%20and%20landscapes%2C%20golden%20warm%20atmosphere%2C%20classical%20Chinese%20painting%20style%2C%20epic%20historical%20composition&width=1400&height=600&seq=movie-9-banner&orientation=landscape",
    featured: false,
    tags: ["国漫巅峰", "历史史诗", "唐诗"],
    updateDate: "2026-08-01",
  },
  {
    id: 10,
    title: "独行月球2",
    slug: "moon-man-2",
    category: "comedy",
    year: 2026,
    rating: 7.9,
    duration: "122分钟",
    director: "张吃鱼",
    cast: ["沈腾", "马丽"],
    description: "独孤月在月球上的冒险还在继续！当他以为终于能回到地球时，一个意外的发现让他不得不再次踏上月球，展开一段更加荒诞搞笑的太空之旅。",
    descriptionHtml: "<p>独孤月在月球上的冒险还在继续！当他以为终于能回到地球时，一个意外的发现让他不得不再次踏上月球，展开一段更加荒诞搞笑的太空之旅。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20space%20comedy%20movie%20poster%20with%20astronaut%20on%20moon%20surface%2C%20humorous%20tone%2C%20bright%20lunar%20landscape%2C%20cinematic%20style%2C%20clean%20poster&width=600&height=900&seq=movie-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Humorous%20space%20themed%20cinematic%20banner%20with%20astronaut%20on%20moon%20surface%2C%20bright%20lunar%20landscape%2C%20comedy%20film%20style%2C%20cinematic%20composition&width=1400&height=600&seq=movie-10-banner&orientation=landscape",
    featured: false,
    tags: ["沈腾马丽", "科幻喜剧", "爆笑"],
    updateDate: "2026-07-27",
  },
  {
    id: 11,
    title: "满江红2",
    slug: "full-river-red-2",
    category: "drama",
    year: 2026,
    rating: 8.3,
    duration: "159分钟",
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译"],
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇的谋杀案牵扯出更大的阴谋，小兵张大与亲兵营副统领孙均在限时一个时辰内破案。",
    descriptionHtml: "<p>南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇的谋杀案牵扯出更大的阴谋。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20with%20Song%20dynasty%20soldiers%2C%20dark%20courtyard%20setting%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20clean%20poster&width=600&height=900&seq=movie-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20cinematic%20banner%20with%20ancient%20Chinese%20courtyard%20at%20night%2C%20dramatic%20torch%20lighting%2C%20tense%20atmosphere%2C%20Song%20dynasty%20setting&width=1400&height=600&seq=movie-11-banner&orientation=landscape",
    featured: false,
    tags: ["张艺谋", "历史悬疑", "群星"],
    updateDate: "2026-07-29",
  },
  {
    id: 12,
    title: "凡人修仙传",
    slug: "mortal-cultivation",
    category: "tvseries",
    year: 2026,
    rating: 8.6,
    duration: "40集/45分钟",
    director: "杨阳",
    cast: ["杨洋", "金晨"],
    description: "一个普通的山村少年韩立，凭借自身的努力和合理的算计，在残酷的修仙世界中一步步走向巅峰。动画改编真人版，还原经典修仙之路。",
    descriptionHtml: "<p>一个普通的山村少年韩立，凭借自身的努力和合理的算计，在残酷的修仙世界中一步步走向巅峰。</p>",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20TV%20series%20poster%20with%20cultivator%20in%20ancient%20Chinese%20landscape%2C%20mystical%20atmosphere%2C%20golden%20and%20green%20tones%2C%20dramatic%20composition&width=600&height=900&seq=movie-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20cinematic%20banner%20with%20mountains%20and%20mist%2C%20ancient%20temples%2C%20mystical%20cultivation%20atmosphere%2C%20dramatic%20lighting%2C%20TV%20series%20style&width=1400&height=600&seq=movie-12-banner&orientation=landscape",
    featured: false,
    tags: ["修仙", "古装玄幻", "热门IP"],
    updateDate: "2026-07-31",
  },
];

export const faqItems = [
  {
    question: "八戒影院的影片资源是否免费？",
    answer: "是的，八戒影院所有影片资源均免费提供在线观看，无需注册、无需付费，打开网站即可畅享高清影视内容。",
  },
  {
    question: "观看影片需要安装播放器吗？",
    answer: "不需要。八戒影院采用最新的HTML5播放技术，支持主流浏览器直接播放，无需安装任何插件或播放器，打开即看。",
  },
  {
    question: "影片更新频率是怎样的？",
    answer: "我们每天都会同步更新最新上映的电影和热播电视剧，确保您能够在第一时间观看到最新的影视内容。国产剧通常当天更新，海外剧集也会在第一时间上线。",
  },
  {
    question: "八戒影院的画质如何？",
    answer: "我们提供高清甚至超清画质的影片资源，大部分内容支持1080P高清播放。同时采用先进的视频编码技术，确保在不缓冲的情况下流畅播放。",
  },
  {
    question: "为什么叫八戒影院？",
    answer: "八戒是中国古典名著《西游记》中的经典角色，寓意接地气、亲民、有趣。我们希望八戒影院能像八戒一样，成为大家日常娱乐生活中不可或缺的一部分，提供轻松愉快的观影体验。",
  },
  {
    question: "支持手机和平板观看吗？",
    answer: "完全支持！八戒影院采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅舒适的观影体验。",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "影迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20clean%20simple%20background%2C%20casual%20style&width=80&height=80&seq=avatar-1&orientation=squarish",
    rating: 5,
    comment: "八戒影院真的太棒了！资源更新超快，画质清晰，而且完全免费。我现在每天下班回家第一件事就是打开八戒影院追剧。",
    date: "2026-07-28",
  },
  {
    id: 2,
    name: "追剧达人",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20clean%20simple%20background%2C%20modern%20style&width=80&height=80&seq=avatar-2&orientation=squarish",
    rating: 5,
    comment: "对比了好几个平台，八戒影院是我用过最好用的免费影视网站。分类清晰，搜索方便，最重要的是真的不卡顿！推荐给所有爱看电影的朋友。",
    date: "2026-07-25",
  },
  {
    id: 3,
    name: "老影迷",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20man%20portrait%20avatar%2C%20gentle%20smile%2C%20clean%20simple%20background%2C%20mature%20style&width=80&height=80&seq=avatar-3&orientation=squarish",
    rating: 4,
    comment: "作为一个看了几十年电影的老影迷，八戒影院的片库让我很惊喜。很多经典老片都能找到，而且画质修复得很好，点赞！",
    date: "2026-07-20",
  },
];

export const aboutInfo = {
  brand: {
    title: "品牌故事",
    content: [
      "八戒影院成立于2020年，致力于为广大华语观众提供高品质的免费在线影视观看服务。我们的名字来源于《西游记》中的经典角色猪八戒，象征着我们亲民、接地气的服务理念。",
      "经过多年的发展，八戒影院已经成为华语地区最具影响力的免费影视平台之一。我们拥有海量的影片资源库，涵盖电影、电视剧、动漫、综艺等多种类型的优质内容。",
      "我们的团队由一群热爱影视的年轻人组成，每天都在努力为用户提供最新的影视资源和最佳的观影体验。我们相信，好的影视作品应该被更多人看到。",
    ],
  },
  reputation: {
    title: "用户口碑",
    stats: [
      { label: "日均访问用户", value: "500万+" },
      { label: "影片资源数量", value: "10万+" },
      { label: "用户好评率", value: "98.5%" },
      { label: "年更新量", value: "3万+" },
    ],
  },
  contact: {
    title: "联系我们",
    email: "service@bajiecinema.com",
    wechat: "bajiecinema",
    qq: "1234567890",
    address: "北京市朝阳区影视产业园区八戒影院总部",
    workingHours: "周一至周日 9:00 - 22:00",
  },
};